import { HttpMethod } from 'app/utils/network';
import { API } from 'app/utils/request';

export const addSpecialist = (specialistRequest, authToken) => {
  const urlPath = '/consultant/addConsultant';
  const additionalHeader = { Authorization: `Bearer ${authToken}` };
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: specialistRequest,
    additionalHeader: additionalHeader
  });
};

export const updateSpecialist = (specialistRequest, authToken) => {
  const urlPath = '/consultant/updateConsultant';
  const additionalHeader = { Authorization: `Bearer ${authToken}` };
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: specialistRequest,
    additionalHeader: additionalHeader
  });
};

export const getAllSpecialistsDetails = (authToken) => {
  const urlPath = '/consultant/getAllConsultantDetails';
  const additionalHeader = { Authorization: `Bearer ${authToken}` };
  return API.request({
    method: HttpMethod.GET,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};

export const addSpecialistAccount = (accountRequest, authToken) => {
  const urlPath = '/consultant/addAccount';
  const additionalHeader = { Authorization: `Bearer ${authToken}` };
  return API.request({
    method: HttpMethod.POST,
    urlPath: urlPath,
    body: accountRequest,
    additionalHeader: additionalHeader
  });
};

export const deleteSpecialistAccount = (id, authToken) => {
  const urlPath = `/consultant/removeConsultantDetails/${id}`;
  const additionalHeader = { Authorization: `Bearer ${authToken}` };
  return API.request({
    method: HttpMethod.DELETE,
    urlPath: urlPath,
    additionalHeader: additionalHeader
  });
};
